import logo from './logo.svg';
import './App.css';
import AppRouter from './Approuter';

function App() {

  // for disabling right click

  // useEffect(() => {
  //   const disableRightClick = (event) => event.preventDefault();
  //   document.addEventListener("contextmenu", disableRightClick);

  //   return () => {
  //     document.removeEventListener("contextmenu", disableRightClick);
  //   };
  // }, []);

  return (
    <div className="App">
      <AppRouter/>
    </div>
  );
}

export default App;
